export default __webpack_public_path__ + "static/media/Groups.7792784d.svg";